import React, { useState, useEffect } from "react";
import { Navbar, Container } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../assets/image/jotylogo.png";
import India from "../assets/image/IndiaFlag.png";
import "./nav&foot.css";

const NavBar = () => {
  const [expanded, setExpanded] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const updateCartCount = () => {
      const user = JSON.parse(localStorage.getItem("user"));

      const cartKey = user?.email ? `cart_${user.email}` : "cart_guest";

      const cart = JSON.parse(localStorage.getItem(cartKey)) || [];
      const totalItems = cart.reduce(
        (sum, item) => sum + (item.quantity || 1),
        0,
      );
      setCartCount(totalItems);
    };

    const updateLoginStatus = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      setIsLoggedIn(loggedIn);

      const user = JSON.parse(localStorage.getItem("user"));

      if (loggedIn && user) {
        setUserData(user);
      } else {
        setUserData(null);
      }
    };

    updateCartCount();
    updateLoginStatus();

    window.addEventListener("storage", () => {
      updateCartCount();
      updateLoginStatus();
    });

    window.addEventListener("cartUpdated", updateCartCount);
    window.addEventListener("loginUpdated", updateLoginStatus);

    return () => {
      window.removeEventListener("cartUpdated", updateCartCount);
      window.removeEventListener("loginUpdated", updateLoginStatus);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown &&
        !event.target.closest(".profile-dropdown-container")
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  const closeNavbar = () => setExpanded(false);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("user");

    setIsLoggedIn(false);
    setUserData(null);
    setShowDropdown(false);

    window.dispatchEvent(new Event("loginUpdated"));

    navigate("/");
    closeNavbar();
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownItemClick = (action) => {
    setShowDropdown(false);
    closeNavbar();

    switch (action) {
      case "cart":
        navigate("/cart");
        break;
      case "orders":
        navigate("/MyOrders");
        break;
      case "paymentHistory":
        navigate("/PaymentHistory");
        break;
      case "login":
        navigate("/login");
        break;
      case "register":
        navigate("/register");
        break;
      case "profile":
        navigate("/profile");
        break;
      default:
        break;
    }
  };

  const ProfileInfo = () => (
    <div
      onClick={() => handleDropdownItemClick("profile")}
      className="profile-dropdown-item profile-info"
    >
      <i className="fa-solid fa-user" />

      <div className="profile-text">
        <div className="profile-name">
          {userData?.name ||
            userData?.customer_name ||
            userData?.username ||
            "User"}
        </div>

        <div className="profile-email">
          {userData?.email || "No email found"}
        </div>
      </div>
    </div>
  );

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className="navbar"
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/" onClick={closeNavbar}>
          <div className="ra-nav-text">
            <img
              src={Logo}
              alt="Jyotirvani Logo"
              style={{
                width: "100px",
                height: "61px",
                background: "#f5deb3",
                borderRadius: "50%",
              }}
            />
          </div>
        </Navbar.Brand>

        <div className="mobile-nav-header">
          <Navbar.Toggle
            aria-controls="navbarNav"
            onClick={() => setExpanded(!expanded)}
            className="custom-navbar-toggler"
          />

          <div className="mobile-navbar-logo">
            <NavLink to="/" onClick={closeNavbar} className="mobile-logo-link">
              <img src={Logo} alt="Jyotirvani Logo" className="navbar-logo" />
            </NavLink>
          </div>

          <div className="mobile-profile-action">
            <div
              className="profile-dropdown-container"
              style={{ position: "relative", cursor: "pointer" }}
            >
              <button
                onClick={toggleDropdown}
                className="profile-action-button"
                title={isLoggedIn ? "Profile Menu" : "Login Menu"}
              >
                <i className="bi bi-person-circle"></i>
              </button>
              {showDropdown && (
                <div className="desktop-profile-dropdown">
                  {isLoggedIn ? (
                    <>
                      <ProfileInfo />

                      <div
                        onClick={() => handleDropdownItemClick("cart")}
                        className="profile-dropdown-item"
                      >
                        <i className="fa-solid fa-shopping-cart" />
                        My Cart ({cartCount})
                      </div>

                      <div
                        onClick={() => handleDropdownItemClick("orders")}
                        className="profile-dropdown-item"
                      >
                        <i className="fa-solid fa-box" />
                        My Orders
                      </div>
                      <div
                        onClick={() =>
                          handleDropdownItemClick("paymentHistory")
                        }
                        className="profile-dropdown-item"
                      >
                        <i className="fa-solid fa-receipt" />
                        Payment History
                      </div>

                      <div
                        onClick={handleLogout}
                        className="profile-dropdown-item logout"
                      >
                        <i className="fa-solid fa-sign-out-alt" />
                        Logout
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        onClick={() => handleDropdownItemClick("cart")}
                        className="profile-dropdown-item"
                      >
                        <i className="fa-solid fa-shopping-cart" />
                        My Cart ({cartCount})
                      </div>

                      <div
                        onClick={() => handleDropdownItemClick("login")}
                        className="profile-dropdown-item"
                      >
                        <i className="fa-solid fa-sign-in-alt" />
                        Login
                      </div>

                      <div
                        onClick={() => handleDropdownItemClick("register")}
                        className="profile-dropdown-item"
                      >
                        <i className="fa-solid fa-user-plus" />
                        Register
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <Navbar.Collapse id="navbarNav" className="justify-content-center">
          <nav className="nav">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Home
            </NavLink>

            <NavLink
              to="/Homan"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Book A Pooja
            </NavLink>

            <NavLink
              to="/ShopCategoryCard"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Jyotirvani Shop
            </NavLink>

            <NavLink
              to="/AstrologerSection"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Astrologer
            </NavLink>

            <NavLink
              to="/AstrologerGallery"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Jyotirvani Gallery
            </NavLink>

            <NavLink
              to="/Blog"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Blog
            </NavLink>

            <NavLink
              to="/AboutUs"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              About Us
            </NavLink>

            <NavLink
              to="/Contact"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={closeNavbar}
            >
              Contact Us
            </NavLink>

            <div className="ra-nav-number-mobile">
              <div className="tm-nav-contact-panel" style={{ color: "#fff" }}>
                <a href="tel:+919616339090" className="vibrating-icon">
                  <i
                    className="fa-solid fa-phone-volume"
                    style={{ color: "#4f6cf7" }}
                  ></i>
                  <img
                    src={India}
                    alt="India Flag"
                    style={{
                      width: "15px",
                      height: "10px",
                      marginRight: "1px",
                      marginLeft: "10px",
                      verticalAlign: "middle",
                    }}
                  />
                  +91 9616339090
                </a>
              </div>
            </div>
          </nav>
        </Navbar.Collapse>

        <div className="desktop-nav-actions">
          <div className="ra-nav-number-destop">
            <div className="tm-nav-contact-panel" style={{ color: "#fff" }}>
              <a href="tel:+919616339090" className="vibrating-icon">
                <i
                  className="fa-solid fa-phone-volume"
                  style={{ color: "#4f6cf7" }}
                ></i>
                <img
                  src={India}
                  alt="India Flag"
                  style={{
                    width: "20px",
                    height: "15px",
                    marginRight: "1px",
                    marginLeft: "10px",
                    verticalAlign: "middle",
                  }}
                />
                +91 9616339090
              </a>
            </div>
          </div>

          <div
            className="profile-dropdown-container desktop-profile-container"
            style={{ position: "relative", cursor: "pointer" }}
          >
            <button
              onClick={toggleDropdown}
              className="desktop-profile-button"
              title={isLoggedIn ? "Profile Menu" : "Login Menu"}
            >
              <i className="bi bi-person-circle"></i>
            </button>

            {showDropdown && (
              <div className="desktop-profile-dropdown">
                {isLoggedIn ? (
                  <>
                    <ProfileInfo />

                    <div
                      onClick={() => handleDropdownItemClick("cart")}
                      className="profile-dropdown-item"
                    >
                      <i className="fa-solid fa-shopping-cart" />
                      My Cart ({cartCount})
                    </div>
                    <div
                      onClick={() => handleDropdownItemClick("orders")}
                      className="profile-dropdown-item"
                    >
                      <i className="fa-solid fa-box" />
                      My Orders
                    </div>
                    <div
                      onClick={() => handleDropdownItemClick("paymentHistory")}
                      className="profile-dropdown-item"
                    >
                      <i className="fa-solid fa-receipt" />
                      Payment History
                    </div>

                    <div
                      onClick={handleLogout}
                      className="profile-dropdown-item logout"
                    >
                      <i className="fa-solid fa-sign-out-alt" />
                      Logout
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      onClick={() => handleDropdownItemClick("cart")}
                      className="profile-dropdown-item"
                    >
                      <i className="fa-solid fa-shopping-cart" />
                      My Cart ({cartCount})
                    </div>

                    <div
                      onClick={() => handleDropdownItemClick("login")}
                      className="profile-dropdown-item"
                    >
                      <i className="fa-solid fa-sign-in-alt" />
                      Login
                    </div>

                    <div
                      onClick={() => handleDropdownItemClick("register")}
                      className="profile-dropdown-item"
                    >
                      <i className="fa-solid fa-user-plus" />
                      Register
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default NavBar;
